import { useQuery } from "@apollo/client";
import { LIST_HELP_REQUESTS } from "../graphQl/SupportAPI";
import { toSupportPagination } from "../../../constants/supportStatus";

export const useHelpRequests = ({ page = 1, pageSize = 10, status, entityType, skip = false } = {}) => {
  const { data, loading, error, refetch } = useQuery(LIST_HELP_REQUESTS, {
    variables: {
      paginationParams: toSupportPagination(page, pageSize),
      status: status || undefined,
      entityType: entityType || undefined,
    },
    skip,
    fetchPolicy: "cache-and-network",
  });

  const result = data?.QR_LIST_HELP_REQUEST?.data;

  return {
    helpRequests: result?.content || [],
    totalElements: result?.totalElements || 0,
    loading,
    error,
    refetch,
  };
};
